import { getPublicMembershipConfig } from '@/lib/memberships-api-client';

export interface BrandConfig {
  id: string; // companies.id
  brand_key: string | null;
  domain: string | null;
  logo_url: string | null;
  primary_color: string | null;
  secondary_color: string | null;
  terms_url: string | null;
  enrollment_config: Record<string, any> | null;
}

/**
 * Resolve the brand/company configuration for the current host.
 *
 * Primary strategy:
 *   - Look up companies.domain == host
 * Fallback strategy:
 *   - Map known hosts to company ids (useful in dev or before DNS is wired)
 */
export async function resolveBrandConfig(host: string): Promise<BrandConfig> {
  const res = await getPublicMembershipConfig(host);
  return res.company as BrandConfig;
}
